var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[((!_vm.loading && !_vm.isLoggedIn) || (_vm.isLoggedIn && _vm.user && !_vm.loading))?_c('router-view',{class:{arb: _vm.isArb,
  teacher: _vm.user && _vm.user.isTeacher(),
  student: !_vm.user || !_vm.user.isTeacher()}}):[_vm._v(" Loading... ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }